var AccordionType;

(function (AccordionType) {
  AccordionType["DEFAULT"] = "accordion-default";
  AccordionType["FILLEDROWS"] = "accordion-filled-rows";
  AccordionType["DARKMODE"] = "accordion-darkmode";
})(AccordionType || (AccordionType = {}));

export { AccordionType };
//# sourceMappingURL=Accordion.types.js.map
